<template>
  <div>
    <v-radio-group
      v-model="selection"
      row>
    <v-radio v-for="language in languages" :value="language" :label="language" :key="language"></v-radio>
  </v-radio-group>
  </div>
</template>

<script>
export default {
  data: () => ({
    selection: "EN"
  }),
  computed: {
    languages() {
      return this.$store.getters.languages;
    }
  },
  watch: {
    selection() {
      this.$store.commit("SET_CURRENT_LANGUAGE", this.selection);
    }
  }

}
</script>
